import { createInitializeOnce } from './utilities';

const initializeOnce = createInitializeOnce();

// Blank the select before the page unloads so that when restoring
// on back navigation from external sites, it always lands on the
// same empty state. This keeps the select and its button in sync.
const resetTicketSelectors = () => {
    document.querySelectorAll('.event-detail__selector').forEach((el) => {
        el.value = '';
    });
};
window.addEventListener('pagehide', resetTicketSelectors);

export default function setupTicketSelector() {
    document.querySelectorAll('.event-detail__selector').forEach((el) => {
        const btn = el.closest('.event-detail__buttons')?.querySelector('.event-detail__btn');

        const updateBtn = () => {
            if (!btn) return;

            if (el.value) {
                btn.setAttribute('href', el.value);
                btn.classList.remove('disabled');
                btn.removeAttribute('aria-disabled');
            } else {
                btn.removeAttribute('href');
                btn.classList.add('disabled');
                btn.setAttribute('aria-disabled', 'true');
            }
        };

        updateBtn();

        if (!initializeOnce(el)) {
            return;
        }

        el.addEventListener('change', updateBtn);
    });

    // Show the sticky header on scroll
    document.querySelectorAll('.event-detail__wrap').forEach((wrapper) => {
        const header = wrapper.querySelector('.event-detail-header');

        if (!initializeOnce(header)) {
            return;
        }

        // Create the IntersectionObserver instance
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    wrapper.classList.remove('scrolled');
                } else {
                    wrapper.classList.add('scrolled');
                }
            });
        });

        // Start observing the element
        observer.observe(header);
    });
}
